import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SwitchToggle from '../SwitchToggle';
import Slider from '../Slider';
import { triggerEvent } from '../../utils';
import { ContentEditorSection, FieldSet, FieldSetLabel } from './styles';

const GridSettings = ({ editor, data, payload, setPayload, translations }) => {
  const { useAutoSave } = editor;
  const defaultSettings = data.grid_settings || {};
  const getGridSettings = () => ({ showGrid, snapToGrid, gridSize });

  const [showGrid, setShowGrid] = useState(defaultSettings.showGrid || false);
  const [snapToGrid, setSnapToGrid] = useState(defaultSettings.snapToGrid || false);
  const [gridSize, setGridSize] = useState(defaultSettings.gridSize || 30);

  const appTexts = translations.app;

  const dispatchEvent = (name, data) => {
    if (useAutoSave) {
      triggerEvent(name, data);
    }
  };

  useEffect(() => {
    const grid_settings = getGridSettings();
    if (JSON.stringify(defaultSettings) !== JSON.stringify(grid_settings)) {
      setPayload({ ...payload, grid_settings, immediateSave: true });
    }
  }, [showGrid, snapToGrid, gridSize]);

  useEffect(() => {
    dispatchEvent('showGrid', showGrid);
  }, [showGrid]);

  useEffect(() => {
    dispatchEvent('snapToGrid', snapToGrid);
  }, [snapToGrid]);

  useEffect(() => {
    dispatchEvent('gridSize', gridSize);
  }, [gridSize]);

  useEffect(() => {
    if (data.grid_settings && JSON.stringify(data.grid_settings) !== JSON.stringify(getGridSettings())) {
      setShowGrid(data.grid_settings.showGrid);
      setSnapToGrid(data.grid_settings.snapToGrid);
      setGridSize(data.grid_settings.gridSize);
    }
  }, [JSON.stringify(data.grid_settings)]);

  return (
    <ContentEditorSection>
      <FieldSet>
        <FieldSetLabel>{appTexts.gridSettings}</FieldSetLabel>
        <SwitchToggle id="showGrid" defaultChecked={showGrid} onChange={() => setShowGrid(!showGrid)}>
          {appTexts.show_grid}
        </SwitchToggle>

        <SwitchToggle id="snapToGrid" defaultChecked={snapToGrid} onChange={() => setSnapToGrid(!snapToGrid)}>
          {appTexts.snap_to_grid}
        </SwitchToggle>

        <Slider id="gridSize" value={parseInt(gridSize)} onChange={(value) => setGridSize(value)}>
          {appTexts.grid_size}
        </Slider>
      </FieldSet>
    </ContentEditorSection>
  );
};

export default GridSettings;

GridSettings.propTypes = {
  editor: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  payload: PropTypes.object.isRequired,
  setPayload: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
};
